import * as React from 'react';

import {Quote} from 'shells/sales-documents/quote';

import type {
    GetInvoiceById_invoice as Invoice,
    SalesDocumentUpdateInput,
    QuoteProductsUpdateInput,
    QuoteSubtotalItemsUpdateInput,
} from 'nutshell-graphql-types';

import {
    useGetPossibleProducts,
    useGetUserNames,
    useUpdateQuote,
    useUpdateQuoteProduct,
    useUpdateQuoteSubtotal,
    useUpdateQuoteTemplate,
    useUpdateQuoteTemplateProduct,
} from '../../shared/graphql/hooks';

type Props = {
    invoice: Invoice;
    isTemplate: boolean;
    toggleHasActiveSection: (isActive: boolean) => void;
};

export function InvoiceWrapper(props: Props) {
    const {users, isLoading} = useGetUserNames(props.isTemplate);
    const {quotePossibleProducts} = useGetPossibleProducts(props.invoice.id, props.isTemplate);

    const {updateQuote} = useUpdateQuote();
    const {updateQuoteProduct} = useUpdateQuoteProduct();
    const {updateQuoteSubtotal} = useUpdateQuoteSubtotal();
    const {updateQuoteTemplate} = useUpdateQuoteTemplate();
    const {updateQuoteTemplateProduct} = useUpdateQuoteTemplateProduct();

    const handleSaveInvoice = (invoice: SalesDocumentUpdateInput) => {
        if (props.isTemplate) {
            updateQuoteTemplate(invoice);
        } else {
            updateQuote(invoice);
        }
    };

    const handleSaveProductTable = (quote: QuoteProductsUpdateInput) => {
        if (props.isTemplate) {
            updateQuoteTemplateProduct(quote);
        } else {
            updateQuoteProduct(quote);
        }
    };

    const handleSaveSubtotalTable = (quote: QuoteSubtotalItemsUpdateInput) => {
        updateQuoteSubtotal(quote);
    };

    return (
        <Quote
            quote={props.invoice}
            isTemplate={props.isTemplate}
            toggleHasActiveSection={props.toggleHasActiveSection}
            handleSaveProductTable={handleSaveProductTable}
            handleSaveQuote={handleSaveInvoice}
            handleSaveSubtotalTable={handleSaveSubtotalTable}
            isLoading={isLoading}
            quotePossibleProductsEdges={quotePossibleProducts}
            users={users}
        />
    );
}
